export default __webpack_public_path__ + "static/media/elysha.e5027310.png";